import { useContent } from "@/content/ContentContext";

export default function Marquee() {
  const content = useContent();
  const row = [...content.marquee, ...content.marquee, ...content.marquee];
  return (
    <div
      data-testid="editorial-marquee"
      aria-hidden="true"
      className="overflow-hidden border-y border-[#0B1A33]/10 bg-skyline py-4"
    >
      <div className="flex w-max animate-marquee">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0 items-center">
            {row.map((t, i) => (
              <span
                key={`${half}-${i}`}
                className="flex items-center whitespace-nowrap font-display text-lg italic text-[#0B1A33]"
              >
                <span className="px-6">{t}</span>
                <span className="text-[#0B1A33]/40">&#10022;</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
